import { handleSettledPromises } from "@bcmi-labs/art-toolkit/utils"
import { noop } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"

import { $rqViewsApiClient } from "@/api/groups"
import { $rqNotificationsApiClient } from "@/api/notifications"
import { query } from "@/api/query"
import { getXOrganizationHeaders } from "@/api/utils"
import { MY_SPACE } from "@/constants/spaces"
import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/spaceoverview/statistics/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  loader: async ({ context: { queryClient } }) => {
    const spaces = await queryClient.query({ ...query.space.list, staleTime: "static" })

    const spaceIds = spaces.map(space => space.id).concat(MY_SPACE.id)

    // Preload data
    handleSettledPromises(
      spaceIds.map(spaceId =>
        Promise.all([
          queryClient.query(query.space.members(spaceId)).catch(noop),
          queryClient
            .query(
              $rqNotificationsApiClient.queryOptions("get", "/notifications", {
                params: { header: getXOrganizationHeaders(spaceId) }
              })
            )
            .catch(noop),
          queryClient
            .query(
              $rqViewsApiClient.queryOptions("get", "/groups/v1/devices", {
                params: {
                  header: getXOrganizationHeaders(spaceId)
                }
              })
            )
            .catch(noop),
          queryClient
            .query(
              $rqViewsApiClient.queryOptions("get", "/groups/v1/things", {
                params: {
                  header: getXOrganizationHeaders(spaceId)
                }
              })
            )
            .catch(noop)
        ])
      )
    )
  }
})
